import { useSyncExternalStore } from "react";
import { readLocal, subscribeLocal } from "@/lib/local-store";

/** A localStorage value that re-renders when it changes (in this tab or another). */
export function useLocalValue(key: string): string | null {
  return useSyncExternalStore(
    subscribeLocal,
    () => readLocal(key),
    () => null,
  );
}
